// 員工編輯預期排班的狀態資料

import * as types from '../actionType';

let initState = [];


function staffSalaryListState(state = initState, action) {
  switch (action.type) {
      case types.GET_STAFF_SALARY_LIST_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default staffSalaryListState;